import { RealtimeChannel } from '@supabase/supabase-js';
import { supabase } from '../supabase/client';
import { getDeviceId } from '../auth/auth-service';

let deviceChannel: RealtimeChannel | null = null;

export function initializeDeviceListener(userId: string) {
  if (deviceChannel) {
    return;
  }

  const deviceFingerprint = getDeviceId();

  deviceChannel = supabase
    .channel(`public:user_devices:user_id=eq.${userId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'user_devices',
        filter: `user_id=eq.${userId}`,
      },
      (payload) => {
        const updatedDevice = payload.new;
        if (
          updatedDevice.device_fingerprint === deviceFingerprint &&
          updatedDevice.is_active === false
        ) {
          // Use scope:'local' — the server session is already gone, so a
          // network signOut would either fail or be redundant. Local-only
          // clears tokens instantly and triggers the auth state listener.
          supabase.auth.signOut({ scope: 'local' }).finally(() => {
            window.location.href = '/sign-in?revoked=true';
          });
        }
      }
    )
    .subscribe((status) => {
      if (status === 'SUBSCRIBED') {
        console.log('[realtime] Device enforcement listener connected');
      }
    });
}

export function cleanupDeviceListener() {
  if (deviceChannel) {
    supabase.removeChannel(deviceChannel);
    deviceChannel = null;
  }
}
